import {
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react';

import { createJazzClient } from '@salutejs/jazz-sdk-web';

import { useGlobalContext } from '../../../../shared/contexts/globalContext';
import { validateURL } from '../../../../shared/utils/validateURL';

export const NewClientForm: FC = () => {
  const { sdk, eventBus } = useGlobalContext();

  const host = "https://salutejazz.ru/";

  const [status, setStatus] = useState<
    'idle' | 'failure' | 'success' | 'pending'
  >('idle');

  const createClient = useCallback(
    async (host: string) => {
      if (!sdk) return;
      setStatus('pending');
      try {
        await createJazzClient(sdk, {
          serverUrl: host,
        });

        console.log('Created JazzClient');
        setStatus('success');
      } catch (error) {
        eventBus({
          type: 'error',
          payload: { title: 'Error create JazzClient' },
        });
        setStatus('failure');
      }
    },
    [sdk, eventBus],
  );

  const handleCreateClient = useCallback(async () => {
    if (!host) {
      console.log('host is empty');
      return;
    }

    if (!validateURL(host)) {
      console.log('Invalid url address');
      return;
    }

    await createClient(host);
  }, [host, createClient]);

  useEffect(() => {
    handleCreateClient();
  }, [handleCreateClient]);

  console.log("JazzClient status: ", status)

  return null;
};
